const carriculamData = [
  {
    title: "Classes PG–UKG",
    description:
      "Learning through stories, games, activities, music, and creative experiences that make every day engaging and enjoyable.",
    image: "https://hacktoskill.com/opsteam/AiBuilderCup/card-people.webp",
    pixels: "https://hacktoskill.com/opsteam/AiBuilderCup/card-pixels-a.webp",
  },
  {
    title: "Classes 1–5",
    description:
      "Develop strong foundations in language, mathematics, science, creativity, and essential learning skills.",
    image: "https://hacktoskill.com/opsteam/AiBuilderCup/card-people.webp",
    pixels: "https://hacktoskill.com/opsteam/AiBuilderCup/card-pixels-a.webp",
  },
  {
    title: "Classes 6–8",
    description:
      "Strengthen concepts through deeper subject learning, practical activities, technology, and critical thinking.",
    pixels: "https://hacktoskill.com/opsteam/AiBuilderCup/card-pixels-b.webp",
  },
  {
    title: "Classes 9–10",
    description:
      "Prepare for board examinations with focused academics, regular practice, doubt support, assessments, and competitive awareness.",
    image: "https://hacktoskill.com/opsteam/AiBuilderCup/card-people.webp",
    pixels: "https://hacktoskill.com/opsteam/AiBuilderCup/card-pixels-b.webp",
  },
];

export default carriculamData;